export const sizeMapping = {
  sm: 'small',
  md: 'medium',
  l: 'large',
  xl: 'extraLarge'
} as const;
